import { render, staticRenderFns } from "./ContractTypeModal.vue?vue&type=template&id=21c9a80a&scoped=true&"
import script from "./ContractTypeModal.vue?vue&type=script&lang=js&"
export * from "./ContractTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./ContractTypeModal.vue?vue&type=style&index=0&id=21c9a80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c9a80a",
  null
  
)

export default component.exports